import styled from "@emotion/styled";

export const SpinnerStyle = styled("div")`
  display: inline-block;

  &.spinner__fit {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    z-index: 5;
  }

  .spinner {
    &__item {
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
    }
  }
`;
